import styled from 'styled-components';

import { Button } from '../Button';

export const StyledExternalLinkButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 4px;
`;
